import type { SVGProps } from 'react';

const SvgNoticeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M15.7715 4.56811C17.0831 4.05497 18.5 5.02195 18.5 6.43041V15.9499C18.4997 17.3901 17.0229 18.3582 15.7021 17.7839L10.5 15.5222V17.7498C10.5 18.7162 9.7165 19.4998 8.75 19.4998C7.7835 19.4998 7 18.7162 7 17.7498V9.24975C7.00008 8.69539 7.25788 8.20119 7.66016 7.88061C7.83612 7.72171 8.04208 7.59245 8.27148 7.50268L15.7715 4.56811Z'
      fill='currentColor'
    />
    <path d='M6 14.0001V8.00006C5 8.00006 3 8.60006 3 11.0001C3 13.4001 5 14.0001 6 14.0001Z' fill='currentColor' />
  </svg>
);
export default SvgNoticeFilled;
